/* eslint-disable  */
import React, { Component } from 'react';
import { ConnectedProps, connect } from'react-redux';
import { confirmWrapper } from 'src/components/Dialog';
import { AppRootState } from 'src/store';
import withRouter from '../../hooks/withRouter';
import API from '../../network';
import {
  CandidateAppliedJobsProps,
  CandidateAppliedJobsState,
  CandidateAppliedJobsViewRendererProps,
} from './types';

import ViewRenderer from './views';

type CandidateAppliedJobsPropsWithRedux = CandidateAppliedJobsProps & ConnectedProps<typeof connector>;
class CandidateAppliedJobs extends Component<CandidateAppliedJobsPropsWithRedux, CandidateAppliedJobsState> {
  constructor(props: CandidateAppliedJobsPropsWithRedux) {
    super(props);

    const { reduxProps } = this.props;
    const { selectedTalentPoolProfile } = reduxProps;
    const { candidateInfo } = selectedTalentPoolProfile;

    this.state = {
      loading: false,
      loadingHistory: false,
      appliedJobs: [],
      jobHistory: {},
      jobStatuses: [],
      profileInfo: candidateInfo,
      updatingForm: false,
    };
  }

  static getDerivedStateFromProps(newData: CandidateAppliedJobsPropsWithRedux, prevData: CandidateAppliedJobsState) {
    const { reduxProps } = newData;
    const { selectedTalentPoolProfile } = reduxProps;
    const { candidateInfo } = selectedTalentPoolProfile;
    if (prevData.profileInfo !== candidateInfo) {
      return {
        profileInfo: candidateInfo,
      }
    }
    return null;
  }

  componentDidMount() {
    const { reduxProps } = this.props;
    const { selectedTalentPoolProfile } = reduxProps;
    this.setState({ profileInfo: selectedTalentPoolProfile?.candidateInfo });
    this.fetchAppliedJobs();
    // this.getAllJobStatuses();
  }

  fetchAppliedJobs = async () => {
    this.setState({
      loading: true,
    });

    try {
      const { router: { params: { candidateId } } } = this.props;
      const response: any = await API
        .getInstance()
        .fetchAppliedJobs(candidateId);
      this.setState({
        appliedJobs: response,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  getCandidateJobHistory = async (jobId: number, expanded: boolean) => {
    if (expanded) {
      this.setState({
        loadingHistory: true,
      });
      try {
        const { router: { params: { candidateId } } } = this.props;
        const { jobHistory } = this.state;
        const request = {
          jobOrderId: jobId,
          hashKey: candidateId,
        };
        const response: any = await API
          .getInstance()
          .getCandidateJobHistory(request);
        const updatedJobHistory = { ...jobHistory };
        updatedJobHistory[jobId] = response;
        this.setState({
          jobHistory: updatedJobHistory,
        });
      } catch (e) {
        await confirmWrapper('Something went wrong', {
          hideSecondaryBtn: true,
          variant: 'danger',
        });
      } finally {
        this.setState({
          loadingHistory: false,
        });
      }
    }
  };

  getAllJobStatuses = async () => {
    this.setState({
      loading: true,
    });
    try {
      const jobStatusesResponse: any = await API.getInstance().getAllJobStatuses();
      this.setState({
        jobStatuses: jobStatusesResponse,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  onUpdateJobStatus = async (requestData: any) => {
    this.setState({ updatingForm: true });
    const { reduxProps } = this.props;
    const { selectedTalentPoolProfile } = reduxProps;
    const candidateId = selectedTalentPoolProfile?.candidateInfo?.candidateId;
    try {
      await API.getInstance().updateJobStatus({
        ...requestData,
        candidateId,
      });
      await confirmWrapper('Information Saved Successfully', {
        variant: 'success',
        autoClose: true,
        primaryBtnLabel: 'ok',
        hideSecondaryBtn: true,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        updatingForm: false,
      });
    }
  };

  updateCandidateComments = async(data : any) => {
    try{
      await API.getInstance().updateStatusComments(data);
      const message = 'Comments added successfully!';
      await confirmWrapper(message, {
        hideSecondaryBtn: true,
        hidePrimaryBtn: true,
        variant: 'success',
        autoClose: true,
      });
      this.getCandidateJobHistory(data?.jobOrderId, true);
    }catch(e: any){
      await confirmWrapper(`failed updating comments ${e?.message}`, {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    }
  }

  getProps = (): CandidateAppliedJobsViewRendererProps => {
    const {
      appliedJobs,
      jobStatuses,
      jobHistory,
      loading,
      loadingHistory,
      profileInfo,
      updatingForm,
    } = this.state;

    return {
      appliedJobs,
      jobStatuses,
      jobHistory,
      loading,
      loadingHistory,
      profileInfo,
      updatingForm,
      updateJobStatus: this.onUpdateJobStatus,
      getCandidateJobHistory: this.getCandidateJobHistory,
      updateCandidateComments: this.updateCandidateComments,
    };
  };

  render() {
    const viewProps: CandidateAppliedJobsViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

const mapStateToProps = (reduxProps: AppRootState) => ({
  reduxProps,
});

const connector = connect(mapStateToProps, null);
export default connector(withRouter(CandidateAppliedJobs));
